var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12.8889V7.88892H5C4.46957 7.88892 3.96086 7.6782 3.58579 7.30313C3.21071 6.92806 3 6.41935 3 5.88892C3 5.35848 3.21071 4.84978 3.58579 4.4747C3.96086 4.09963 4.46957 3.88892 5 3.88892H19V7.88892",
    stroke: "#251169",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.88892V19.8889C3 20.4193 3.21071 20.9281 3.58579 21.3031C3.96086 21.6782 4.46957 21.8889 5 21.8889H21V16.8889",
    stroke: "#251169",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.8889C17.4696 12.8889 16.9609 13.0996 16.5858 13.4747C16.2107 13.8498 16 14.3585 16 14.8889C16 15.4193 16.2107 15.9281 16.5858 16.3031C16.9609 16.6782 17.4696 16.8889 18 16.8889H22V12.8889H18Z",
    stroke: "#251169",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/icon_wallet.e6a3c594a6a4c95b7d45763cb7c6b0ca.svg";
export { ForwardRef as ReactComponent };